var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('items-list',{attrs:{"businessId":_vm.businessId,"query":_vm.query,"filters":_vm.filters,"targetEntityId":_vm.targetEntityId,"category":"all"},on:{"deny":_vm.deny,"approve":_vm.approve,"assign":_vm.assign,"comment":_vm.comment,"del":_vm.del,"history":_vm.history}})],1)
}
var staticRenderFns = []

export { render, staticRenderFns }